<!-- Close button -->
<div class="absolute top-3 right-3">
  <button mat-mini-fab aria-label="Dialog schließen" [mat-dialog-close]="true" color="light" data-test="cancelButton">
    <mat-icon svgIcon="sli-schliessen-gross-20"></mat-icon>
  </button>
</div>
<!-- End close button -->

<!-- Content -->
@if (dialogPage <= firstPage) {
  <h1 class="mb-4 heading-4-sans">{{ 'personal-onboarding.title_page1' | translate }}</h1>
}
@if (dialogPage === secondPage) {
  <h1 class="mb-4 heading-4-sans">{{ 'personal-onboarding.title_page2' | translate }}</h1>
}
@if (dialogPage >= lastPage) {
  <h1 class="mb-4 heading-4-sans">{{ 'personal-onboarding.title_page3' | translate }}</h1>
}
<mat-dialog-content>
  @if (dialogPage <= firstPage) {
    <div>
      <p>{{ 'personal-onboarding.text_page1' | translate }}</p>
    </div>
  }
  @if (dialogPage === secondPage) {
    <div>
      <img class="drop-shadow-lg" ngSrc="assets/images/onboarding-personal-toggle-button.png"
           alt="Umschalter für alle Programme und meine Programme"
           height="125" width="769">
      <p class="mt-4" [innerHTML]="'personal-onboarding.text1_page2' | translate"></p>
      <p class="mt-4">{{ 'personal-onboarding.text2_page2' | translate }}</p>
    </div>
  }
  @if (dialogPage >= lastPage) {
    <div>
      <p>{{ 'personal-onboarding.text_page3' | translate }}</p>
    </div>
  }
</mat-dialog-content>
<!-- End content -->

<!-- Action buttons -->
<mat-dialog-actions class="flex flex-col gap-4 sm:flex-row sm:justify-end">
  @if (dialogPage > firstPage) {
    <button mat-button class="w-full sm:w-0" (click)="onPreviousPage()">
      {{ 'personal-onboarding.previous_page_button' | translate }}
    </button>
  }
  @if (dialogPage >= lastPage) {
    <button mat-button color="primary" class="w-full sm:w-0" [mat-dialog-close]="true" data-test="acceptButton">
      {{ 'personal-onboarding.accept_button' | translate }}
    </button>
  }
  @if (dialogPage < lastPage) {
    <button mat-button color="primary" class="w-full sm:w-0" (click)="onNextPage()" data-test="nextButton">
      {{ 'personal-onboarding.next_page_button' | translate }}
    </button>
  }
</mat-dialog-actions>
<!-- End action buttons -->
